import { useRef, useMemo } from 'react';
import defaultOptionDescription from '../../internal/components/option/option-announcer';
export var useAnnouncement = function (_a) {
    var announceSelected = _a.announceSelected, highlightedOption = _a.highlightedOption, parentMap = _a.parentMap, selectedAriaLabel = _a.selectedAriaLabel, renderHighlightedAriaLive = _a.renderHighlightedAriaLive;
    var prevAnnouncedGroup = useRef(undefined);
    var prevAnnouncement = useRef('');
    return useMemo(function () {
        var message = '';
        if (highlightedOption) {
            var group = parentMap.get(highlightedOption);
            var groupToAnnounce = group === prevAnnouncedGroup.current ? undefined : group;
            prevAnnouncedGroup.current = group;
            message = (renderHighlightedAriaLive || defaultOptionDescription)(highlightedOption.option, groupToAnnounce === null || groupToAnnounce === void 0 ? void 0 : groupToAnnounce.option);
            // prepend selectedAriaLabel, if custom `renderHighlightedAriaLive` was not specified
            if (announceSelected && !renderHighlightedAriaLive) {
                message = (selectedAriaLabel ? selectedAriaLabel + ' ' : '') + message;
            }
        }
        prevAnnouncement.current = message;
        return message;
    }, [announceSelected, highlightedOption, parentMap, selectedAriaLabel, renderHighlightedAriaLive]);
};
//# sourceMappingURL=use-announcement.js.map